//SCREENSHOT_LIST
export const USER_SCREENSHOT_LIST_REQUEST = "USER_SCREENSHOT_LIST_REQUEST";
export const USER_SCREENSHOT_LIST_SUCCESS = "USER_SCREENSHOT_LIST_SUCCESS";
export const USER_SCREENSHOT_LIST_FAIL = "USER_SCREENSHOT_LIST_FAIL";

//DASHBOARD_SCREENSHOT_LIST
export const USER_DASHBOARD_SCREENSHOT_LIST_REQUEST = "USER_DASHBOARD_SCREENSHOT_LIST_REQUEST";
export const USER_DASHBOARD_SCREENSHOT_LIST_SUCCESS = "USER_DASHBOARD_SCREENSHOT_LIST_SUCCESS";
export const USER_DASHBOARD_SCREENSHOT_LIST_FAIL = "USER_DASHBOARD_SCREENSHOT_LIST_FAIL";

//UPDATE_SCREENSHOT_REASON
export const UPDATE_SCREENSHOT_REASON_REQUEST =
  "UPDATE_SCREENSHOT_REASON_REQUEST";
export const UPDATE_SCREENSHOT_REASON_SUCCESS =
  "UPDATE_SCREENSHOT_REASON_SUCCESS";
export const UPDATE_SCREENSHOT_REASON_FAIL = "UPDATE_SCREENSHOT_REASON_FAIL";

//DELETE_SCREENSHOT
export const DELETE_SCREENSHOT_REQUEST = "DELETE_SCREENSHOT_REQUEST";
export const DELETE_SCREENSHOT_SUCCESS = "DELETE_SCREENSHOT_SUCCESS";
export const DELETE_SCREENSHOT_FAIL = "DELETE_SCREENSHOT_FAIL";
